import script from "./PartPayDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./PartPayDialog.vue?vue&type=script&lang=ts&setup=true"

import "./PartPayDialog.vue?vue&type=style&index=0&id=496f2537&lang=scss"

const __exports__ = script;

export default __exports__